import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames/bind';
import { Icon } from '../Icon';
import { EmojiIcon } from '../EmojiIcon';
import { getPlanDiscountPercent } from '../../shared/plan-helpers';
import styles from './SubscriptionCardV3.css';

const cx = classnames.bind(styles);

function renderSubtitle(subscriptionData) {
    const weeks = subscriptionData.billingPeriod?.value;

    if (subscriptionData.trial) {
        return (
            <>
                {subscriptionData.trial.price}
                {' now, then '}
                {subscriptionData.price}
                {` every ${weeks} weeks`}
            </>
        );
    }

    return (
        <>
            {subscriptionData.price}
            {` every ${weeks} weeks`}
        </>
    );
}

function SubscriptionCardV3({ subscriptionData, selectedSubscriptionData, selectSubscription, spriteVersion, name = 'subscription-plan' }) {
    const isActive = subscriptionData.plan === selectedSubscriptionData.plan;
    const discountPercent = getPlanDiscountPercent(subscriptionData);
    const isDiscountShown = discountPercent > 0;
    const oldPrice = subscriptionData.displayOldPrice ?? subscriptionData.price;
    const newPrice = subscriptionData.trial?.price ?? subscriptionData.price;

    return (
        <label className={cx('root', { active: isActive })}>
            <input
                type='radio'
                name={name}
                value={subscriptionData.plan}
                checked={isActive}
                onChange={() => selectSubscription(subscriptionData)}
                className={styles.input}
            />
            {subscriptionData.isPopular && (
                <div className={styles.popularBanner}>Best offer</div>
            )}
            <div className={styles.content}>
                <div className={styles.detailsRow}>
                    <span className={styles.radio}>
                        <span className={styles.radioDot} />
                    </span>
                    <div className={styles.planInfo}>
                        <p className={styles.name}>{subscriptionData.membershipName ?? subscriptionData.name}</p>
                        <p className={styles.subtitle}>{renderSubtitle(subscriptionData)}</p>
                    </div>
                    <div className={styles.priceInfo}>
                        {isDiscountShown && <p className={styles.oldPrice}>{oldPrice}</p>}
                        <p className={styles.newPrice}>{newPrice}</p>
                        {isDiscountShown && (
                            <div className={styles.saleBadge}>
                                <EmojiIcon name='fire' version={spriteVersion} className={styles.fireEmoji} />
                                <span>{subscriptionData.isDiscountBadgeHidden ? 'SALE' : `SAVE ${discountPercent}%`}</span>
                            </div>
                        )}
                    </div>
                </div>
                {isActive && (
                    <>
                        <div className={styles.divider} />
                        <ul className={styles.features}>
                            <li className={styles.feature}>
                                <span className={styles.featureIcon}><Icon name='checkTick' /></span>
                                <p><strong>Personalized follow-up</strong>{' questions'}</p>
                            </li>
                            <li className={styles.feature}>
                                <span className={styles.featureIcon}><Icon name='checkTick' /></span>
                                <p><strong>Voice or text</strong>{' answers'}</p>
                            </li>
                            <li className={styles.feature}>
                                <span className={styles.featureIcon}><Icon name='checkTick' /></span>
                                <p><strong>Automatic</strong>{' chapter editing'}</p>
                            </li>
                            <li className={styles.feature}>
                                <span className={styles.featureIcon}><Icon name='checkTick' /></span>
                                <p>{'Your completed '}<strong>Digital Memoir</strong>{' with photos'}</p>
                            </li>
                            <li className={styles.feature}>
                                <span className={styles.featureIcon}><Icon name='checkTick' /></span>
                                <p>{'Cancel '}<strong>anytime</strong></p>
                            </li>
                            <li className={styles.feature}>
                                <span className={styles.featureIcon}><Icon name='checkTick' /></span>
                                <p><strong>Keep access</strong>{' to everything you create'}</p>
                            </li>
                        </ul>
                    </>
                )}
            </div>
        </label>
    );
}

SubscriptionCardV3.propTypes = {
    subscriptionData: PropTypes.object.isRequired,
    selectedSubscriptionData: PropTypes.object.isRequired,
    selectSubscription: PropTypes.func.isRequired,
    spriteVersion: PropTypes.string.isRequired,
    name: PropTypes.string
};

export {
    SubscriptionCardV3
};
